import React, { ReactElement, useCallback, useEffect, useRef, useState } from 'react'
import styles from './OauthEdit.module.scss'
import { OauthEditTypes } from './OauthEdit.types'
import { IAppState } from '../../../core/store/store'
import { connect } from 'react-redux'
import { getOauthClientById, updateOauthClient } from '../Settings.actions'
import { Translate } from 'react-localize-redux'
import { Button, Tooltip } from 'antd'
import { reg, urlRegExpression } from '../../../core/utils/constants'
import { fetchAllOauthClients } from '../../tenants/create-account-signing-client/AccountSigningClient.actions'
import { translate } from 'shared/helpers/utils'
import { FormFieldSize, Input, Select } from '@digicert/dcone-common-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faPlusCircle, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import history from 'core/history/history'

const OauthEdit = (props: OauthEditTypes): ReactElement => {
  const client = {
    id: '',
    name: '',
    status: '',
    clientId: '',
    createdDate: ''
  }

  const errorLoginRef = useRef<HTMLParagraphElement>(null)
  const [id, setId] = useState('')
  const [clientId, setClientId] = useState('')
  const [clientSecret, setClientSecret] = useState('')
  const [integrationName, setIntegrationName] = useState('')
  const [redirectUrls, setRedirectUrls] = useState([''])
  const clipBoardRef = useRef<HTMLInputElement>(null) // eslint-disable-next-line no-undef
  const errorNameRef = useRef<HTMLParagraphElement>(null) // eslint-disable-next-line no-undef
  const errorUrlRef = useRef<HTMLParagraphElement>(null)
  const [copyText, setCopyText] = useState(<Translate id={'addOauthIntegration.clientIdClipBoardTooltipMessage'} />)
  const [copiedInfo, setCopiedInfo] = useState(false)
  const [buttonCopy] = useState(<Translate id={'addOauthIntegration.updateButtonLabel'} />)
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [friendlyNameInlineError, setFriendlyNameInlineError] = useState('common.form.validation.required')
  const [redirectUrlInlineError, setRedirectUrlInlineError] = useState('common.form.validation.required')
  const [invalidRegex, setInvalidRegex] = useState(false)
  const [ref, setRef] = useState(errorUrlRef.current)
  const [val, setVal] = useState('')
  const [clients, setClients] = useState([client])
  const [inlineError, setInlineError] = useState(false)
  const [accessTokenTtl, setAccessTokenTtl] = useState<number>()
  const [refreshTokenTtl, setRefreshTokenTtl] = useState<number>()
  const [accessTokenPositiveNumberError, setAccessTokenPositiveNumberError] = useState(false)
  const [refreshTokenPositiveNumberError, setRefreshTokenPositiveNumberError] = useState(false)
  const [accessTokenMissingError, setAccessTokenMissingError] = useState(false)
  const [refreshTokenMissingError, setRefreshTokenMissingError] = useState(false)
  const [accountId, setAccountId] = useState('')
  const [application, setApplication] = useState(translate('common.form.select') as string)
  const [applicationOptions, setApplicationOptions] = useState<any>([])
  const [loginUrl, setLoginUrl] = useState('')
  const [loginUrlInlineError, setLoginUrlInlineError] = useState('common.form.validation.required')
  const [refUrl, setRefUrl] = useState(errorLoginRef.current)
  const [urlVal, setUrlVal] = useState('')
  const [invalidUrlRegex, setInvalidUrlRegex] = useState(false)
  const [inlineErrorLoginUrl, setInlineErrorLoginUrl] = useState(false)

  function copyToClipboard (): void {
    if (clipBoardRef && clipBoardRef.current) {
      clipBoardRef.current.select()
    }
    setCopiedInfo(true)
    document.execCommand('copy')
    setCopyText(<Translate id={'addOauthIntegration.clipBoardTooltipSuccessMessage'} />)
  }

  function handleIntegrationName (event: React.ChangeEvent<HTMLInputElement>): void {
    setIntegrationName(event.target.value)
    const ref = errorNameRef.current
    if (ref) {
      event.target.value === '' ? ref.style.display = 'block' : ref.style.display = 'none'
      setInlineError(false)
      if (event.target.value.length > 256) {
        setFriendlyNameInlineError('addOauthIntegration.friendlyNameLengthValidation')
        ref.style.display = 'block'
        setInlineError(true)
      }
      if (clients.find(client => client.name.trim().toLowerCase() === event.target.value .trim().toLowerCase() && client.id !== id) !== undefined) {
        setFriendlyNameInlineError('addOauthIntegration.friendlyNameUnique')
        ref.style.display = 'block'
        setInlineError(true)
      }
    }
  }

  function addRedirectUrl (): void {
    setRedirectUrls(redirectUrls.concat(''))
  }

  function deleteRedirectUrl (url: string): void {
    const tmpUrls = redirectUrls.filter(item => item !== url)
    setRedirectUrls(tmpUrls)
    const ref = errorUrlRef.current
    if (ref) {
      tmpUrls.length === 0 ? ref.style.display = 'block' : ref.style.display = 'none'
    }
  }

  useEffect(() => {
    props.fetchAllOauthClients(props.match.params.configId ? props.match.params.id : undefined).then((response: any) => {
      setClients(response[0])
    })
  }, [fetchAllOauthClients])

  function handleIntegrationRedirectUrl (index: number, event: React.ChangeEvent<HTMLInputElement>): void {
    const tmpUrls = [...redirectUrls]
    tmpUrls[index] = event.target.value
    setRedirectUrls(tmpUrls)
    const ref = errorUrlRef.current
    const val = event.target.value
    if (ref) {
      setRef(ref)
      setVal(val)
      setRedirectUrlInlineError('common.form.validation.required')
      ref.style.display = 'none'
      setInlineError(false)
      try {
        const regexObj = new RegExp(event.target.value, ''); 
        setInvalidRegex(false)
      } catch(e) {
          setInvalidRegex(true)
      }
      if (event.target.value.length > 2048) {
        setRedirectUrlInlineError('addOauthIntegration.redirectUrlLengthValidation')
        ref.style.display = 'block'
        setInlineError(true)
      }
      if (event.target.value === '') {
        ref.style.display = 'block'
        setRedirectUrlInlineError('common.form.validation.required')
        setInlineError(true)
      }
    }
  }

  function handleLoginUrl (event: React.ChangeEvent<HTMLInputElement>): void {
    setLoginUrl(event.target.value)
    const ref = errorLoginRef.current
    if (ref) {
      setRefUrl(ref)
      setUrlVal(event.target.value)
      ref.style.display = 'none'
      setInlineErrorLoginUrl(false)
      try {
        const regexObj = new RegExp(event.target.value, '');
        setInvalidUrlRegex(false)
      } catch(e) {
        setInvalidUrlRegex(true)
      }
      if (event.target.value === '') {
        ref.style.display = 'block'
        setLoginUrlInlineError('common.form.validation.required')
        setInlineErrorLoginUrl(true)
      }
      if (event.target.value.length > 2048) {
        setLoginUrlInlineError('addOauthIntegration.redirectUrlLengthValidation')
        ref.style.display = 'block'
        setInlineErrorLoginUrl(true)
      }
    }
  }


  function addIntegration () {
    const payload = {
      id: clientId,
      name: integrationName,
      'oauth_config': {
        'redirect_uris': redirectUrls,
        'login_url': loginUrl,
        'access_token_ttl': accessTokenTtl ? accessTokenTtl * 60 : accessTokenTtl,
        'refresh_token_ttl':refreshTokenTtl  ? refreshTokenTtl* 60 : refreshTokenTtl
      },
      enabled: true,
      'account_id': accountId,
      'application_id': application
    }
    const val = props.match.params.configId ? props.match.params.configId : props.match.params.id
    props.updateOauthClient(payload, val).then((response: any) => {
      if (response) {
        setIntegrationName('')
        setRedirectUrls([])
        setButtonDisabled(true)
      }
    })
    const selection = document.getSelection()
    if (selection) {
      selection.removeAllRanges()
    }
    setTimeout(function (){
      history.goBack()
    }, 1000)
  }

  function cancelIntegration (): void {
    history.goBack()
  }

  const accessTokenTtlValidity = useCallback(() => {
    if (accessTokenPositiveNumberError) {
      return translate('dashboardLicense.validation.positiveNumber')
    }
    else if (accessTokenMissingError) {
      return translate('notifications.errors.valueMissingError')
    }
    else if (accessTokenTtl && accessTokenTtl < 5) {
      return translate('addOauthIntegration.accessTokenLowerLimit')
    }
    else if (accessTokenTtl && accessTokenTtl > 1440) {
      return translate('addOauthIntegration.accessTokenUpperLimit')
    }
},[accessTokenTtl, accessTokenPositiveNumberError, accessTokenMissingError])

const handleAccessTokenTtl = useCallback((event) => {
  const input = event.target.value
  if (
    !/^\d*$/.test(input) ||
    /^0[0-9].*$/.test(input) ||
    /^\d*\.\d*$/.test(input) ||
    /^([a-zA-Z])\w+/.test(input)
  ) {
    setAccessTokenPositiveNumberError(true)
  } else if(input === '') {
    setAccessTokenMissingError(true)
  }
  else {
    setAccessTokenTtl(Number(input))
    setAccessTokenPositiveNumberError(false)
    setAccessTokenMissingError(false)
  }
},[accessTokenTtl, setAccessTokenTtl])

const refreshTokenTtlValidity = useCallback(() => {
  if (refreshTokenPositiveNumberError) {
    return translate('dashboardLicense.validation.positiveNumber')
  }
  else if (refreshTokenMissingError) {
    return translate('notifications.errors.valueMissingError')
  }
  else if (refreshTokenTtl && refreshTokenTtl < 5) {
    return translate('addOauthIntegration.refreshTokenLowerLimit')
  }
  else if (refreshTokenTtl && refreshTokenTtl > 2880) {
    return translate('addOauthIntegration.refreshTokenUpperLimit')
  }
},[refreshTokenTtl, refreshTokenPositiveNumberError, refreshTokenMissingError])

const handleRefreshTokenTtl = useCallback((event) => {
  const input = event.target.value
  if (
    !/^\d*$/.test(input) ||
    /^0[0-9].*$/.test(input) ||
    /^\d*\.\d*$/.test(input) ||
    /^([a-zA-Z])\w+/.test(input)
  ) {
    setRefreshTokenPositiveNumberError(true)
  } else if(input === '') {
    setRefreshTokenMissingError(true)
  } else {
    setRefreshTokenPositiveNumberError(false)
    setRefreshTokenMissingError(false)
    setRefreshTokenTtl(Number(input))
  }
},[refreshTokenTtl, setRefreshTokenTtl])

  useEffect(() => {
    const val = props.match.params.configId ? props.match.params.configId : props.match.params.id
    props.getOauthClientById(val).then((response: any) => {
      if(response) {
        setClientId(response[0].client_id)
        setClientSecret(response[0].client_secret)
        setIntegrationName(response[0].name)
        setRedirectUrls(response[0].oauth_config.redirect_uris)
        setLoginUrl(response[0].oauth_config.login_url)
        setId(response[0].id)
        setAccessTokenTtl(response[0].oauth_config.access_token_ttl === 0 ? 60 : response[0].oauth_config.access_token_ttl / 60)
        setRefreshTokenTtl(response[0].oauth_config.refresh_token_ttl === 0 ? 120 : response[0].oauth_config.refresh_token_ttl / 60)
        setAccountId(response[0].account_id)
        setApplication(response[0].application.id)
        setApplicationOptions([{
          value: response[0].application.id,
          label: response[0].application.name
        }])
      }
    })
  }, [getOauthClientById])

  useEffect(() => {
    if(ref && val !== '') {
      if (invalidRegex) {
        setRedirectUrlInlineError('addOauthIntegration.redirectUrlRegexValidation')
        ref.style.display = 'block'
        setInlineError(true)
      } else if (!urlRegExpression.test(val) && reg.test(val)) {
        setRedirectUrlInlineError('addOauthIntegration.invalidUrl')
        ref.style.display = 'block'
        setInlineError(true)
      }
    }
    if(refUrl && urlVal !== '') {
      if (invalidUrlRegex) {
        setLoginUrlInlineError('addOauthIntegration.redirectUrlRegexValidation')
        refUrl.style.display = 'block'
        setInlineErrorLoginUrl(true)
      } else if (!urlRegExpression.test(urlVal) && reg.test(urlVal)) {
        setLoginUrlInlineError('addOauthIntegration.invalidUrl')
        refUrl.style.display = 'block'
        setInlineErrorLoginUrl(true)
      }
    }
    if (!inlineErrorLoginUrl && !inlineError && redirectUrls.length !== 0 && redirectUrls.every(elem => elem !== '')) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [integrationName, redirectUrls, invalidRegex, ref, val, refUrl, urlVal, invalidUrlRegex, inlineError, inlineErrorLoginUrl])

  return (
    <section className={styles.oAuthEdit}>
      <header className={styles.oAuthAddHeader}>
        <h1>{integrationName} <Translate id={'addOauthIntegration.details'}/></h1>
      </header>

      <form>
        <div className={styles.oAuthInputSection}>
          <h4><Translate id={'addOauthIntegration.inputNameLabel'} /></h4>
          <p><Translate id={'addOauthIntegration.inputNameDescription'} /></p>
          <input className={styles.oAuthInput} type='text' value={integrationName} onChange={handleIntegrationName} />
          <p className={styles.oAuthInputErrorMessage} ref={errorNameRef}><Translate id={friendlyNameInlineError} /></p>
        </div>

        <hr />
        <h3><Translate id={'addOauthIntegration.settingsHeadline'} /></h3>

        <div className={styles.oAuthInputSection}>
          <h4><Translate id={'addOauthIntegration.inputRedirectLabel'} /></h4>
          <p><Translate id={'addOauthIntegration.inputRedirectDescription'} /></p>

          {redirectUrls.map((item, index) => {
            return (
              <div className={styles.oAuthRedirectInputContainer} key={index}>
                <input className={styles.oAuthInputWithOption} type='text' value={item} onChange={(event):void => { handleIntegrationRedirectUrl(index, event) } } />
                <div className={styles.deleteRedirect}>
                  <FontAwesomeIcon size='lg' icon={faTrashAlt} color='#d9482f' onClick={():void => { deleteRedirectUrl(item) } }/>
                </div>
              </div>
            )
          })}
          <p className={styles.oAuthInputErrorMessage} ref={errorUrlRef}><Translate id={redirectUrlInlineError} /></p>
          <div className={styles.oAuthAddRedirectOption} onClick={addRedirectUrl}>
            <FontAwesomeIcon size='lg' icon={faPlusCircle} /><Translate id={'oauthIntegration.addRedirectUrls'} />
          </div>
        </div>
        <div className={styles.oAuthInputSection}>
          <h4>{translate('addOauthIntegration.inputLoginUri')}</h4>
          <p>{translate('addOauthIntegration.inputLoginUriDescription')}</p>
          <input className={styles.oAuthInput} type='text' value={loginUrl} onChange={handleLoginUrl} />
          <p className={styles.oAuthInputErrorMessage} ref={errorLoginRef}><Translate id={loginUrlInlineError} /></p>
        </div>
        <div className={styles.oAuthInputSection}>
          <Input
              label={translate('addOauthIntegration.accessTokenTtl')}
              size={FormFieldSize.S}
              required
              errors={{valueMissing: translate('notifications.errors.valueMissingError')}}
              defaultValue={accessTokenTtl}
              onChange={handleAccessTokenTtl}
              validate={accessTokenTtlValidity}
            />
        </div>
        <div className={styles.oAuthInputSection}>
        <Input
            label={translate('addOauthIntegration.refreshTokenTtl')}
            size={FormFieldSize.S}
            required
            errors={{valueMissing: translate('notifications.errors.valueMissingError')}}
            defaultValue={refreshTokenTtl}
            onChange={handleRefreshTokenTtl}
            validate={refreshTokenTtlValidity}
          />
        </div>
        <div className={styles.oAuthInputSection}>
          <Select
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            size={FormFieldSize.L}
            allowClear
            defaultValue={application}
            value={application}
            label={translate('addOauthIntegration.application')}
            placeholder={translate('common.form.select')}
            options={applicationOptions}
            optionFilterProp="label"
            showSearch
            disabled
          />
        </div>
        <div className={styles.oAuthInputSection}>
          <p><Translate id={'addOauthIntegration.clientIdLabel'} /></p>
          <input className={styles.oAuthInput} type='text' readOnly value={clientId} ref={clipBoardRef} />
          <Tooltip placement='top' title={copyText}>
            {copiedInfo && (
              <FontAwesomeIcon size='lg' icon={faCheckCircle} className={styles.oAuthClipBoardIcon + ' ' + styles.copied} onClick={copyToClipboard} />
            )
            }
            {!copiedInfo && (
              <FontAwesomeIcon size='lg' icon={faCopy} className={styles.oAuthClipBoardIcon} onClick={copyToClipboard} />
              )
            }
          </Tooltip>
        </div>

        <div className={styles.oAuthInputSection}>
          <p><Translate id={'addOauthIntegration.sharedSecretIdLabel'} /></p>
          <input className={styles.oAuthInput} type='password' readOnly value={clientSecret} />
        </div>

        <div className={styles.oAuthActions}>
          <Button
            size='large'
            htmlType='button'
            className='default-btn'
            onClick={cancelIntegration}>
            <Translate id={'addOauthIntegration.cancelButtonLabel'} />
          </Button>

          <Button
            size='large'
            className='submit-btn'
            disabled={buttonDisabled}
            onClick={addIntegration}>
            {buttonCopy}
          </Button>
        </div>
      </form>
    </section>
  )
}

export default connect(
  (state: IAppState) => {},
  { getOauthClientById, updateOauthClient, fetchAllOauthClients }
)(OauthEdit)
